<template>
  <div>
    <Offers></Offers>
  </div>
</template>

<script>
import Offers from '@/views/offers/index.vue'

export default {
  components: { Offers }
}
</script>